import { FC, PropsWithChildren } from 'react';
import { Flex, Tag, type TagProps } from 'antd';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './GraphCardTitle.translations.json';

const { addTranslations, t } = i18nNsFactory('graph-card-title');
addTranslations(translations);

export interface GraphCardTitleProps extends PropsWithChildren {
  tagLabel: string;
  tagColor: TagProps['color'];
  isRoot?: boolean;
}

export const GraphCardTitle: FC<GraphCardTitleProps> = ({
  tagLabel,
  tagColor,
  isRoot,
  children,
}) => (
  <Flex justify="space-between" align="center" gap="large">
    <Flex align="center" gap="small">
      <Tag style={{ margin: 0 }} color={tagColor}>
        {tagLabel}
      </Tag>
      {isRoot && t('main-element')}
    </Flex>
    {children}
  </Flex>
);
